module.exports = __webpack_public_path__ + "img/banner_tun.31921eaa.webp";